"use client";

import { useTranslations } from "@zapier/i18n";
import { HydratedChatbot, useChatbotActionPermissions } from "@zapier/client";
import { ShareModal, useEmitShareInteractionEvent } from "@zapier/shared";
import { useEffect } from "react";

interface Props {
  chatbot: HydratedChatbot | undefined;
  isOpen: boolean;
  onCloseModal: () => void;
}

export function ChatbotsShareModal({ chatbot, isOpen, onCloseModal }: Props) {
  const t = useTranslations("fallbacks");
  const { emit: emitShareEvent } = useEmitShareInteractionEvent();

  const { canShare, enablePermissionsCheck } = useChatbotActionPermissions(
    chatbot?.id ?? "",
  );

  useEffect(() => {
    if (isOpen) {
      enablePermissionsCheck();
    }
  }, [isOpen, enablePermissionsCheck]);

  return (
    <ShareModal
      allowSharingWithEveryone={true}
      allowSharingWithTeams={true}
      assetId={chatbot?.id ?? ""}
      assetName={chatbot?.name || t("untitled-asset", { assetType: "Chatbot" })}
      assetOwner={chatbot?.owner}
      assetType="chatbot"
      // Setting to false until we're ready to add owner changing
      canChangeOwner={false}
      canShare={canShare}
      emit={(subjectId: string) => {
        emitShareEvent({
          assetId: chatbot?.id,
          optionSelected: "share_chatbot",
          subjectId,
        });
      }}
      isOpen={isOpen}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onCloseModal();
        }
      }}
      roles={["editor", "viewer"]}
    />
  );
}
